import gql from "graphql-tag";

export const LOCK_DOCUMENT = gql`
	subscription lockDocument(
		$id: Int!
	) {
		lockDocument(id: $id)
	}
`;
